import {useEffect, useState} from "react";
import {Dialog, DialogActions, DialogContent, DialogTitle, Step, StepLabel, Stepper} from "@mui/material";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import MaterialPageItemModule from "../modul/MaterialPageItemModule";
import TextFieldValidation from "../table/customer-detales/TextFieldValidation";
import ButtonBack from "../button/ButtonBack";
import ButtonExit from "../button/ButtonExit";
import ButtonAdd from "../button/ButtonAdd";

const FittingsModal = ({
                           initValue,
                           open,
                           onClose,
                           title,
                           handleSubmit,
                           handleModalAlert,
                           loading,
                       }) => {
    const [activeStep, setActiveStep] = useState(0)
    const steps = [
        'Материал',
        'Количество'
    ];
    const [data, setData] = useState(initValue)
    const [materials, setMaterials] = useState({})

    useEffect(() => {
        setData(initValue)
        setMaterials({id: initValue.fittingId, name: initValue.name,})
    }, [initValue])

    const selectMaterial = (material) => {
        setMaterials(material)
    }
    const submit = () => {
        if (activeStep === 0) {
            setActiveStep(1)
        } else {
            const newData = {
                fittingId: materials?.id, name: materials?.name, quantity: data.quantity
            }
            handleSubmit(newData, reset)
        }
    }
    const reset = () => {
        setActiveStep(0)
        onClose()
        setMaterials({})
    }

    return (
        <Dialog open={open} PaperProps={{
            style: {
                minWidth: `${activeStep === 0 ? "1400px" : "800px"}`,
                height: `${activeStep === 0 ? "940px" : "430px"}`,
                borderRadius: 8,
            }
        }}>
            <Box style={{
                padding: 40,
                display: "flex",
                flexDirection: "column",
                gap: 16,
                alignItems: "center"
            }}>
                <DialogTitle sx={{
                    color: (theme) => theme.palette.text.main,
                    padding: 0,
                    fontSize: 24,
                    fontWeight: 700
                }}>{title}</DialogTitle>
                {<Stepper
                    style={{width: 700}}
                    activeStep={activeStep}
                >
                    {steps.map((label) => (
                        <Step key={label}>
                            <StepLabel sx={{
                                ".MuiSvgIcon-root": {
                                    fontSize: 40,
                                    color: "#737478",
                                    "&.Mui-active": {
                                        color: "#3B8BEC",
                                    }
                                },
                                "& .MuiStepLabel-label": {
                                    fontSize: 18,
                                    "&.Mui-active": {
                                        fontWeight: 700,
                                    }
                                }
                            }}>{label}</StepLabel>
                        </Step>
                    ))}
                </Stepper>}
            </Box>
            <Box sx={{
                height: "32px",
                fontSize: "18px",
                margin: "0px 40px 0px 40px",
                display: "flex",
                alignItems: "center",
                borderBottom: materials?.id ? "#3B8BEC 1px solid" : "transparent 1px solid",
                '& .MuiTypography-root': {
                    fontWeight: (theme) => theme.typography.fontWeight,
                    color: (theme) => theme.palette.text.main,
                    '&:first-of-type': {
                        marginRight: '10px'
                    }
                },
            }}>
                <Typography
                    component="p">{materials?.articleNumber || materials?.materialOrganizationOption?.articleNumber}</Typography>
                <Typography
                    component="p">{(materials?.name || materials?.materialOrganizationOption?.name)}</Typography>
            </Box>
            <DialogContent sx={{padding: "0px 20px 0px 40px"}}>
                {(activeStep === 0) ?
                    <MaterialPageItemModule
                        isOrganization={false}
                        selectMaterialId={materials?.id}
                        selectMaterial={selectMaterial}
                        typeMaterial={"PIECE"}
                        subTypeMaterial={"ACCESSORIES"}
                        modal={true}
                        handleModalAlert={handleModalAlert}
                    />
                    : <Box>
                        <TextFieldValidation
                            name="quantity"
                            label="Количество"
                            value={data?.quantity}
                            setCurrValues={setData}
                            required={false}
                        />
                    </Box>}
            </DialogContent>

            <DialogActions style={{padding: 40, display: "flex", justifyContent: "space-between"}}>
                <Box>{activeStep !== 0 &&
                    <ButtonBack text={"Назад"}
                                onClick={() => setActiveStep(0)}/>} </Box>
                <Box>
                    <ButtonExit text={"Выйти"} onClick={reset}/>
                    <ButtonAdd
                        loading={loading}
                        text={"Выбрать"} onClick={submit} disabled={!materials?.id}/>
                </Box>
            </DialogActions>
        </Dialog>
    );
}
export default FittingsModal